import request from '@/services/request'

export default {
  getTraList: {
    url: '/trafficPerformance/page',
    method: 'post',
    desc: '获取流量表现列表'
  },
  traUpload: {
    url: '/trafficPerformance/upload',
    method: 'post',
    desc: '导入流量数据'
  },
  getGoodsInfoDetail: {
    url: '/trafficPerformance/getGoodsInfoDetail',
    method: 'post',
    desc: '流量表现商品详情'
  },
  performanceDetail: {
    url: '/trafficPerformance/performanceDetail',
    method: 'post',
    desc: '流量表现明细'
  },
  createTask: {
    url: '/trafficPerformance/createTask',
    method: 'post',
    desc: '创建任务-手动'
  },
  batchCreateTask: {
    url: '/trafficPerformance/batchCreateTask',
    method: 'post',
    desc: '创建任务-手动-批量'
  },
  /**
   * 获取所有任务列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchPluginHelperTaskListPage(data = {}, options = {}) {
    return request(
      {
        url: '/trafficPerformance/getTaskPage',
        method: 'post',
        desc: '获取所有任务列表'
      },
      {
        ...data
      },
      options
    )
  },
  /**
   * 获取插件状态列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchPluginHelperPluginStatusList(data = {}, options = {}) {
    return request(
      {
        url: '/trafficPerformance/getPluginStatusList',
        method: 'post',
        desc: '获取插件状态列表'
      },
      {
        ...data
      },
      options
    )
  }
}
